import { Option } from "interfaces/dataInterfaces"
import Select from "react-select"
import { useGetCountryQuery } from "services/core/geoBoundaries"

interface CountrySelectorProps {
  onSelect?: (country?: Option) => void
  label?: string
  className?: string
  allowAll?: boolean
  value?: number
}

const SelectAll: Option = { value: 0, name: "All" }

export default function CountrySelector({ onSelect, label, className, allowAll = true, value }: CountrySelectorProps) {
  const { data: countries, isFetching } = useGetCountryQuery()

  let countriesList = allowAll ? [SelectAll] : []
  if (countries?.length) {
    countriesList = [...countriesList, ...countries]
  }

  const handleSelect = (item: Option): void => {
    if (onSelect) onSelect(item)
  }

  return (
    <>
      {label && <label className="wfp--label text-xl">{label}</label>}
      <Select
        isSearchable
        isClearable
        isLoading={isFetching}
        placeholder="Select country"
        className={className || "dropdown mr-4"}
        classNamePrefix="select"
        options={countriesList}
        getOptionLabel={option => option.name}
        getOptionValue={option => option.value.toString()}
        onChange={item => {
          handleSelect({ name: item?.name || "", value: item?.value || 0 })
        }}
        value={countriesList?.find(c => c?.value === value)}
      />
    </>
  )
}
